import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  Box,
  CircularProgress,
  Typography,
  Container,
  Alert,
  useTheme,
} from '@mui/material'
import ActivitiesData from '../../Component/Activities_Components/Activities'
import { useActivity } from '../../Component/context_components/activities_context'

const DepartmentalActivity = () => {
  const { id } = useParams()
  const theme = useTheme()
  const { activitiesData, yearsData, setActivityId } = useActivity()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        setLoading(true)
        if (id && setActivityId) {
          await setActivityId(id)
        }
        if (isMounted) setLoading(false)
      } catch (err) {
        if (isMounted) {
          setError(err.message)
          setLoading(false)
        }
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [id, setActivityId])

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          Error loading activities: {error}
        </Alert>
      </Container>
    )
  }

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="300px"
      >
        <CircularProgress size={60} />
      </Box>
    )
  }

  if (!activitiesData || activitiesData.length === 0) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography
          variant="h5"
          align="center"
          color="textSecondary"
          sx={{ py: 4 }}
        >
          No activities found for this department
        </Typography>
      </Container>
    )
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: '100vh',
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            mb: 4,
            color: theme.palette.primary.main,
          }}
        >
          Department Activities
        </Typography>

        <ActivitiesData data={activitiesData} filterDate={yearsData} />
      </Container>
    </Box>
  )
}

export default DepartmentalActivity
